@if (!callWaiterRequestBill()) {
  <div @fadeIn class="screen-header">
    <svg class="icon" width="40" height="40" fill="none" viewBox="0 0 40 40">
      <path
        fill="#CF0A2C"
        d="M.02 17.936h15.645c.573.893 1.145 1.791 1.718 2.69 2.114 3.3 5.057 5.572 8.643 7.066 1.842.764 3.645.714 5.501-.015 3.3-1.296 5.798-3.638 8.396-6.451v2.729c-.005 3.3-.064 6.605 0 9.905.054 2.967-3.027 6.118-5.99 6.104-.494 0-.988.03-1.477.03-8.297 0-16.594.014-24.89 0C2.76 39.983.058 37.318.018 32.55c-.034-4.208-.015-8.421 0-12.63v-1.985Zm19.608 15.24c1.482 0 1.852-.745 1.852-1.861 0-1.117-.37-1.854-1.852-1.861-3.205-.015-6.823-.03-10.028 0-1.454.013-1.825.744-1.825 1.675 0 .93.37 2.047 1.825 2.047 1.56.024 2.912 0 4.472 0h5.556Zm-8.917-9.305H8.874c-1.47 0-1.84.744-1.84 1.675 0 .93.37 1.694 1.84 1.694 1.124-.02 2.235 0 3.716 0 1.482 0 1.853-.764 1.853-1.694 0-.93-.37-1.675-1.852-1.675h-1.88Z"
      />
      <path
        fill="#CF0A2C"
        d="M40 8.959c0 2.63-.29 5.344-1.662 7.984-1.69 3.24-4.104 5.722-7.448 7.275-1.447.67-2.81.695-4.247.005-5.324-2.55-8.45-6.69-8.958-12.634-.188-2.219-.104-4.462-.045-6.69.055-1.97.608-2.585 2.539-3.086 1.906-.497 3.847-.864 5.728-1.44 2.405-.734 4.702-.257 7.018.333 1.511.387 3.037.72 4.544 1.136 1.664.462 2.335 1.276 2.424 2.973C39.958 6.05 40 7.29 40 8.959Zm-11.648 2.119c-.553-.388-1.012-.725-1.492-1.028-.745-.466-1.447-.268-2 .323-.577.62-.582 1.39-.069 2.034.613.77 1.274 1.524 2.02 2.154 1.146.968 1.921.938 3.047-.084a69.894 69.894 0 0 0 3.502-3.46 2.65 2.65 0 0 0 .657-1.28c.246-1.31-.944-2.247-2.159-1.706-.508.223-.948.63-1.373 1.007-.726.655-1.412 1.355-2.133 2.044v-.005ZM.197 14.431c.099-4.079 2.146-6.584 6.097-6.937 3.006-.268 5.59 0 8.149 0v6.937H.197Z"
      />
    </svg>
    <span class="text">{{ 'invoice.header' | translate }}</span>
  </div>
}

@if (withCallWaiterRequestBill()) {
  @let callWaiterToPayTitleText = 'invoice.callWaiterToPay.title' | translate;
  @let callWaiterToPayDescriptionText = 'invoice.callWaiterToPay.description' | translate;
  @let callWaiterToPayActionText = 'invoice.callWaiterToPay.action' | translate;
  @let callWaiterToPayCancelTitleText = 'invoice.callWaiterToPayCancel' | translate;
  @let callWaiterToPayCancelActionText = 'invoice.callWaiterToPay.actionCancel' | translate;

  @if (!callWaiterRequestBill()) {
    <div @fadeIn class="content" coreActivitySection="CallWaiterToPay">
      <img class="icon" src="/images/ready-to-pay.svg" width="98" height="120" alt="">
      <div class="title">{{ callWaiterToPayTitleText }}</div>
      <div class="description">{{ callWaiterToPayDescriptionText }}</div>
      <button
        class="btn wide call-waiter"
        coreUserActivityClickTracking="CallWaiterToPay"
        [disabled]="callWaiterMain() || callWaiterAnotherRound()"
        (click)="handlerCallWaiterToPay($event)"
      >
        <svg width="32" height="32" fill="none" viewBox="0 0 32 32">
          <path
            fill="currentColor"
            d="M.015 14.349h12.517c.458.714.916 1.433 1.375 2.151 1.69 2.64 4.045 4.459 6.914 5.654 1.473.61 2.915.571 4.4-.012 2.64-1.037 4.64-2.91 6.717-5.161v2.183c-.004 2.64-.051 5.284 0 7.924.044 2.374-2.421 4.895-4.792 4.883-.395 0-.79.024-1.181.024-6.638 0-13.275.012-19.913 0-3.844-.008-6.005-2.14-6.037-5.955-.027-3.366-.011-6.737 0-10.103v-1.588ZM15.703 26.54c1.185 0 1.481-.596 1.481-1.489 0-.893-.296-1.483-1.482-1.489a600.938 600.938 0 0 0-8.022 0c-1.163.011-1.46.596-1.46 1.34 0 .745.297 1.638 1.46 1.638 1.249.02 2.33 0 3.578 0h4.445Zm-7.134-7.444h-1.47c-1.175 0-1.471.595-1.471 1.34 0 .744.296 1.355 1.471 1.355.9-.015 1.788 0 2.973 0 1.186 0 1.482-.61 1.482-1.355s-.296-1.34-1.482-1.34H8.57Z"
          />
          <path
            fill="currentColor"
            d="M32 7.167c0 2.104-.232 4.275-1.33 6.387-1.351 2.593-3.283 4.578-5.958 5.82-1.157.536-2.248.556-3.398.004-4.259-2.04-6.76-5.351-7.166-10.107-.15-1.775-.083-3.57-.036-5.352.043-1.576.486-2.068 2.03-2.469 1.527-.397 3.08-.69 4.585-1.15 1.923-.59 3.76-.208 5.613.265 1.209.31 2.43.576 3.635.909 1.331.37 1.869 1.02 1.94 2.378.051.988.085 1.981.085 3.315Zm-9.319 1.695c-.442-.31-.81-.58-1.193-.822-.596-.373-1.157-.214-1.6.258-.462.497-.466 1.112-.055 1.628.49.615 1.02 1.219 1.616 1.723.916.774 1.537.75 2.438-.068a55.932 55.932 0 0 0 2.8-2.767 2.12 2.12 0 0 0 .526-1.024c.198-1.048-.755-1.798-1.726-1.366-.407.18-.759.505-1.099.806-.58.524-1.13 1.084-1.707 1.636v-.004ZM.158 11.546c.079-3.264 1.716-5.268 4.877-5.55 2.405-.215 4.472 0 6.519 0v5.55H.158Z"
          />
        </svg>
        <span>{{ callWaiterToPayActionText }}</span>
      </button>
    </div>
  } @else {
    <div @fadeIn class="content" coreActivitySection="CallWaiterToPay">
      <div class="title small">{{ callWaiterToPayCancelTitleText }}</div>
      <img class="logo" src="/images/logo.svg" width="76" height="76" alt=""/>
      <button
        class="btn outline call-waiter-cancel"
        coreUserActivityClickTracking="CallWaiterToPayCancel"
        (click)="handlerCallWaiterToPay($event)"
      >
        {{ callWaiterToPayCancelActionText }}
      </button>
    </div>
  }

  @if (showDisclaimer()) {
    <div class="disclaimer">
      <div class="disclaimer__text" [class.active]="currentLanguage() === 'en-CA'">
        We do not accept Kids Cards, BP Gift Cards, or MyBP Rewards at this location. We apologize for any
        inconvenience this may cause.
      </div>
      <div class="disclaimer__text" [class.active]="currentLanguage() === 'fr-CA'">
        Les cartes pour enfants, les cartes-cadeaux BP et les récompenses MonBP ne sont pas acceptées dans ce
        restaurant. Nous nous excusons pour les inconvénients.
      </div>
    </div>
  }
} @else {
  <div class="content">
    <img class="icon" src="/images/ready-to-pay.svg" width="98" height="120" alt="">
    <div class="title small">{{ 'invoice.title' | translate }}</div>
    <div class="description">{{ 'invoice.description' | translate }}</div>

    @if (qrUrl(); as qrUrl) {
      <img class="qr-code" [src]="qrUrl" width="76" height="76" alt="">
    } @else {
      <img class="qr-code" src="/images/logo.svg" width="76" height="76" alt="">
    }

    <div class="table-name">{{ 'invoice.table' | translate }} {{ table()?.tableName }}</div>
  </div>
}

